import { render } from "./PencilOffOutline.vue?vue&type=template&id=42080830"
import script from "./PencilOffOutline.vue?vue&type=script&lang=js"
export * from "./PencilOffOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__